import {onBeforeUnmount, onMounted} from 'vue';
import {APIService} from '@/core/util/services/api.service';

export const localUrl = (path) =>
  `${(window.appGlobal?.baseUrl || '').replace(/\/$/, '')}/${path.replace(
    /^\//,
    '',
  )}`;

export const resourceUrl = (path) => {
  if (!path) return '';
  if (/^https:\/\//i.test(path)) return path;
  if (/^\/(?!\/)/.test(path)) return localUrl(path);
  return '';
};

export function portalApi(section) {
  const path = `/api/v2/staff/${section}`;
  const service = new APIService(window.appGlobal?.baseUrl || '', path);
  const request = (method, id, data, params) =>
    service
      .request({
        method,
        url: id == null ? path : `${path}/${id}`,
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Cache-Control': 'no-store, no-cache',
          Pragma: 'no-cache',
        },
        ...(data ? {data} : {}),
        ...(params ? {params} : {}),
      })
      .then((response) => response.data.data);
  return {
    list: (params) => request('GET', null, null, params),
    get: (id) => request('GET', id),
    create: (data) => request('POST', null, data),
    act: (id, data) => request('PUT', id, data),
  };
}

export function errorMessage(error) {
  const response = error?.response || error;
  if (response?.status === 409) {
    return 'This record changed while you were working. Your unsaved text is still here. Copy it before reloading the record, then review the latest version.';
  }
  return (
    response?.data?.error?.message ||
    'We could not complete this request. Please try again. Your unsaved text is still here.'
  );
}

export const statusLabel = (status) =>
  ({
    draft: 'Self review in progress',
    self_submitted: 'With supervisor',
    manager_published: 'Ready to acknowledge',
    acknowledged: 'Acknowledged',
    cancelled: 'Cancelled',
    submitted: 'Submitted',
    in_review: 'In review',
    waiting_on_staff: 'Waiting on staff',
    resolved: 'Resolved',
    withdrawn: 'Withdrawn',
  }[status] || status);

export function displayDate(value) {
  if (!value) return '—';
  const date = new Date(value.length === 10 ? `${value}T12:00:00Z` : value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...(value.length === 10 ? {timeZone: 'UTC'} : {}),
  });
}

// Drafts stay in component memory only; confidential text is never persisted in browser storage.
export function useDraftGuard(dirty) {
  const canLeave = () =>
    !dirty.value ||
    window.confirm('Leave this page and discard your unsaved changes?');
  const beforeUnload = (event) => {
    if (dirty.value) {
      event.preventDefault();
      event.returnValue = '';
    }
  };
  const beforeLink = (event) => {
    const link = event.target?.closest?.('a[href]');
    if (
      !link ||
      link.target === '_blank' ||
      link.hasAttribute('download') ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    if (dirty.value) {
      if (!canLeave()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      } else {
        // The user already chose to discard; avoid a second browser leave prompt.
        dirty.value = false;
      }
    }
  };
  onMounted(() => {
    window.addEventListener('beforeunload', beforeUnload);
    document.addEventListener('click', beforeLink, true);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('beforeunload', beforeUnload);
    document.removeEventListener('click', beforeLink, true);
  });
  return {canLeave};
}
